import { Link, useLocation } from "react-router-dom";
import { useSoundPath } from "hooks/useSoundPath";
import PageHeaderAuth from "./PageHeaderAuth";

const PageHeaderNav = ({ setIsNavOpened, isLogged }) => {
  const { pathname, hash } = useLocation();

  const playSound = useSoundPath();

  const scrollToAnchor = () => {
    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  const linkHandler = (e, itemLabel) => {
    setIsNavOpened(false);

    if (pathname === "/" && !itemLabel === "Play Now") {
      scrollToAnchor();
    }
  };

  const homeLinks = [
    {
      label: "Home",
      url: "#home",
    },
    {
      label: "How to Play",
      url: "#how-to-play",
    },
    {
      label: `What's Different`,
      url: "#difference",
    },
  ];

  const links = [
    {
      label: "Dashboard",
      url: "/dashboard",
      class: 'dashboard'
    },
    {
      label: "Inventory",
      url: "/inventory/dates",
    },
    {
      label: "Crafting",
      url: "/crafting/identity",
      class: 'crafting'
    },
    {
      label: "Marketplace",
      url: "/marketplace/cards?status=not_owned,for_sale",
    },
    {
      label: "Buy Packs",
      url: "/buypacks",
      class: 'buypacks'
    },
    // {
    //   label: "Masters Event",
    //   url: '/mastersevent'
    // },
    // {
    //   label: "PVP Tournaments",
    //   url: "/pvp-tournaments"
    // }
  ];

  const getLink = () => (pathname === "/" ? homeLinks : links);

  const getActiveClass = (label) => {
    const formattedLabel = label.split(" ").join("").toLowerCase();
    return pathname.includes(formattedLabel);
  };

  const renderLinks = () => {
    return getLink().map((link) => (
      <Link
        to={link.url}
        key={link.url}
        onClick={(e) => {
          linkHandler(e, link.label)
        }}
        onMouseDown={() => playSound('nav')}
        className={`${getActiveClass(link.label) ? "active" : ""} ${link.label === 'Masters Event' ? 'highlited' : ''} ${link.class ? link.class : ''}`}
      >
        {link.label}
      </Link>
    ));
  };

  return (
    <nav className="page-header__main-nav">
      {renderLinks()}

      <a href="https://form.jotform.com/250774807521156" target="_blank" rel="noreferrer">Bug Report</a>

      {/* {pathname !== '/' && <input type="text" placeholder="Search" />} */}

      {!isLogged && <PageHeaderAuth />}
    </nav>
  );
};

export default PageHeaderNav;
